import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import {
  postMultipleKambiSharesToBetLoop,
  postMultipleSharesToBetLoop,
} from '@core/Areas/BetLoop/helpers/api'

export const postSharedBetToBetLoop = async ({
  ticketSequence = undefined,
  coupon = undefined,
}: PostSharedBetArgs): Promise<{
  results: BetLoopShareResult[]
  successfulCount: number
  failedCount: number
}> => {
  if (ticketSequence) {
    const response = await postMultipleSharesToBetLoop({ ticketSequences: [ticketSequence] })
    return {
      results: response.results,
      successfulCount: response.successfulShares,
      failedCount: response.failedShares,
    }
  }

  if (coupon) {
    const bets = coupon.bets.map(({ betRef }) => ({ couponRef: coupon.couponRef, betRef }))
    const response = await postMultipleKambiSharesToBetLoop({ bets })

    return {
      results: response.results,
      successfulCount: response.successfulShares,
      failedCount: response.failedShares,
    }
  }

  throw new Error('No bet ID provided for share')
}

// =====
// Types
// =====

type PostSharedBetArgs =
  | { ticketSequence: number; coupon?: undefined }
  | { coupon: KambiHistoryCoupon; ticketSequence?: undefined }

type BetLoopShareResult =
  | { success: true; postId: number; errorMessage: null }
  | { success: false; postId: null; errorMessage: string | null }
